import { Divider, Typography, Grid, Tab } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { getDecks, updateHeaderInfo, logout, updateUserProfile, getUserDetails, submitCME, getSASPResidentData, sendSASPResidentAccess } from "../actions";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Link } from "react-router-dom";
import { CopyrightWidget, LoadingCard } from "../components";
import { deviceData, setContainer, getThisYear, getPGY, LOADIGNARRAY, getLoadingPhrases } from "../common";
import { isBrowser, } from 'react-device-detect';

import "../styles/deckCreationStyles.css";
import "../styles/masterStyles.css";

class ResidentClass extends Component {
    state = {
        loading: true,
        program: null,
        resident: null,
        tracking: null,
        loadingtext: 'Loaading...',
        interval: null
    }

    myLoadingTextInterval = () => {
        let cnt = 0;
        let _interval = 3333;
        let interval = setInterval(() => {
            this.setState({
                ...this.state,
                loadingtext: getLoadingPhrases(cnt)
            })
            cnt++;
        }, _interval, cnt);

        return this.setState({
            ...this.state,
            interval: interval
        })
    }

    componentDidMount = async () => {
        await this.props.updateHeaderInfo({
            route:"/resident", 
            name: "SASP", 
            iconTwo: 'menu', 
            iconOne: 'back',
            color: "#00567a",
            interval: null
        });

        const tracking = deviceData(this.props.location, 'navigate');

        this.myLoadingTextInterval();

        await this.props.getSASPResidentData({
            mcid: this.props.user_details.mcid,
            key: this.props.user_details.key,
            residentid: this.props.location.state.residentid,
            programid: this.props.location.state.programid,
            accesslevel: this.props.location.state.accesslevel
        })
        
        return this.setState({
            ...this.state,
            tracking: tracking,
            program: this.props.program
        })
        
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.resident !== this.props.resident) {
            return this.setState({
                ...this.state,
                resident: this.props.resident
            })
        }

        if (prevState.resident !== this.state.resident) {
            clearInterval(this.state.interval);

            return this.setState({
                ...this.state,
                loading: false,
                interval: null
            })
        }
    }

    componentWillUnmount = () => {
        if ( (!this.state.loading) || this.state.interval ) {
            clearInterval(this.state.interval);
            this.setState({ ...this.state, interval: null})
        }
    }

    render () {
        if (this.state.loading) {
            return (
                <LoadingCard text={this.state.loadingtext}/>
            )
        } else {
            return (
                <>
                    <div className="aua-overflow" style={setContainer(isBrowser)}>
                        <Typography className="homeDividerText">Resident Details</Typography>

                        <div style={{ padding: "16px 0 16px"}}>
                            <TableContainer component={Paper}>
                                <Table style={{width: "100%"}} aria-label="simple table">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Resident Name</TableCell>
                                            <TableCell align="right">{this.state.resident.name}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Access Level</TableCell>
                                            <TableCell align="right">{this.state.resident.accessleveltext}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Last Accessed</TableCell>
                                            <TableCell align="right">{this.state.resident.lastaccessed}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>App Version</TableCell>
                                            <TableCell align="right">{this.state.resident.appversion}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>

                        <Typography className="homeDividerText">Results</Typography>

                        <div style={{ padding: "16px 0 16px"}}>
                            <TableContainer component={Paper}>
                                <Table style={{width: "100%"}} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Category</TableCell>
                                            <TableCell align='center'>Resident</TableCell>
                                            <TableCell align='center'>Peer Group</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.resident.data.map((item, index) => {
                                            return (
                                                <TableRow key={`category-${index}`}>
                                                    <TableCell >{item.area}</TableCell>
                                                    <TableCell align='center'>
                                                        {item.scores.user}%
                                                        {/* <small>({item.scores.answered_user} questions)</small> */}
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        {item.scores.peers}%
                                                        {/* <small>({item.scores.answered_peers} questions)</small> */}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                        
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        
                        <CopyrightWidget 
                            style={{width: "auto;"}}
                            begin="2022"
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-32 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                        />
                    </div>
                </>
            );
        }
        
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details, resident, program } = state.auth;
    const { headerText, iconOne, iconTwo } = state.style;
    const { deckList } = state.decks;
    return {
        headerText,
        iconOne,
        iconTwo,
        deckList,
        auth_feedback,
        user_details,
        resident,
        program
    };
};

const ResidentScreen = connect(mapStateToProps, { 
    updateHeaderInfo, getDecks, logout, updateUserProfile, getUserDetails, submitCME, getSASPResidentData, sendSASPResidentAccess
})(
    ResidentClass
);

export { ResidentScreen };
